export const state = {
  filters: {},
  filterIndicatorOptions: [],
  filterSellerOptions: [],
  filterPosOptions: [],
}
export const getters = {
  getFiltersFlat: state => {
    const filters = Object.values(state.filters)
    const filters_flat = []

    if (!filters.length) {
      return filters_flat
    }

    filters.forEach(filter => {
      if (filter instanceof Array && filter.length) {
        filters_flat.push(...filter)
        return
      }
      filters_flat.push(filter)
    })
    return filters_flat
  },
  getFilters: state => state.filters,
  getFiltersBySearchable: (state, searchable) => {
    return state.filters[searchable]
  },
  getFilterIndicatorOptions: state => state.filterIndicatorOptions,
  getFilterSellerOptions: state => state.filterSellerOptions,
  getFilterPosOptions: state => state.filterPosOptions,
}
export const mutations = {
  setFilters: (state, payload) => (state.filters = payload),
  setFilterBySearchable: (state, { searchable, payload }) => {
    state.filters[searchable] = payload
    state.filters = { ...state.filters }
  },
  removeFilterBySearchable: (state, { searchable, value }) => {
    if (!state.filters) {
      return
    }

    const filter_to_remove = state.filters[searchable]

    if (filter_to_remove instanceof Array && filter_to_remove.length > 1) {
      state.filters[searchable] = filter_to_remove.filter(
        entry => entry.value !== value
      )
      state.filters = { ...state.filters }
      return
    }

    delete state.filters[searchable]
    state.filters = { ...state.filters }
  },
  removeSearchable: (state, searchable) => {
    delete state.filters[searchable]
    state.filters = { ...state.filters }
  },
  clearFilters: state => (state.filters = {}),
  setFilterIndicatorOptions: (state, payload) => (state.filterIndicatorOptions = payload),
  setFilterSellerOptions: (state, payload) => (state.filterSellerOptions = payload),
  setFilterPosOptions: (state, payload) => (state.filterPosOptions = payload),
}
export const actions = {
  obtainFiltersAsPayload: ({ state, getters }) => {
    const payload = {}
    const filters = state.filters
    const flat_filters = getters.getFiltersFlat

    if (!flat_filters.length) {
      return payload
    }

    flat_filters?.filter(Boolean)?.forEach(({ searchable, value }) => {
      if (filters[searchable] instanceof Array) {
        const is_already_an_array = payload[searchable] instanceof Array

        is_already_an_array
          ? payload[searchable].push(value)
          : (payload[searchable] = [value])

        return
      }
      payload[searchable] = value
    })

    return payload
  },
  resetFiltersState({ commit }) {
    commit("clearFilters")
    commit("setFilterIndicatorOptions", [])
    commit("setFilterSellerOptions", [])
    commit("setFilterPosOptions", [])
  },
}
